import { getDiscountCodeByUser } from "@/api/discount-codes";
import { queryOptions } from "@tanstack/react-query";

export const discountCodeByUserQuery = (locationId: number) =>
	queryOptions({
		queryKey: ["discount_codes"],
		queryFn: () => getDiscountCodeByUser(locationId),
	});
